import { createContext } from 'react';
class DummyContext {
    constructor() {
        this.root = null;
    }
}
const EngineContext = createContext(new DummyContext());
EngineContext.displayName = 'EngineContext';
export { EngineContext, };
//# sourceMappingURL=engine-context.js.map